import MoneyLogModal from './MoneyLogModal';

export default MoneyLogModal;
